'use client';

import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import TradingChart from './TradingChart';
import OrderBook from './OrderBookPanel';
import TradePanel from './TradePanel';
import { cn } from '@/lib/utils';

type TMobileTabs = 'Chart' | 'Orderbook' | 'Trades';

export default function MobileTabs() {
  const [tab, setTab] = useState<TMobileTabs>('Chart');

  const mobileTabs: TMobileTabs[] = ['Chart', 'Orderbook', 'Trades'];

  const getTabContent = (tab: TMobileTabs) => {
    switch (tab) {
      case 'Chart':
        return <TradingChart />;
      case 'Orderbook':
        return <OrderBook />;
      case 'Trades':
        return <TradePanel />;
    }
  };

  return (
    <Tabs
      value={tab}
      onValueChange={value => setTab(value as TMobileTabs)}
      className={cn('flex flex-1 lg:hidden', tab !== 'Chart' && 'gap-0')}
    >
      <TabsList className='w-full bg-transparent p-0'>
        {mobileTabs.map(tab => (
          <TabsTrigger
            key={tab}
            value={tab}
            className='flex-1 cursor-pointer rounded-none dark:data-[state=active]:border-b dark:data-[state=active]:border-b-white'
          >
            {tab}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent
        value={tab}
        className={cn('flex px-4', tab !== 'Chart' && 'max-lg:px-0')}
      >
        {getTabContent(tab)}
      </TabsContent>
    </Tabs>
  );
}
